import { css } from 'styled-components'

export default css`
  width: 0.76923rem;
  height: 0.76923rem;
`
